<template>
	<div>
		<div class="h-container">
			<main-header class="i-h" :child="child"></main-header>
			<div class="content">

				<div class="content-nav flex-sb col-center">
					<div class="col-center">
						<div class="title col-center">项目过程管理</div>
						<div class="project-info col-center">
							<div class="item col-center">
								<div class="label">项目编号:</div>
								<div class="value">{{information.apply && information.apply.number}}</div>
							</div>
							<div class="item col-center">
								<div class="label">项目名称:</div>
								<div class="value">{{information.apply && information.apply.item_name}}</div>
							</div>
							<div class="item col-center">
								<div class="label">项目责任单位:</div>
								<div class="value">{{information.apply && information.apply.responsible_unit}}</div>
							</div>
						</div>
					</div>
					<!-- <div class="seeManual" @click="opener">查看并下载操作手册</div> -->
				</div>
				<div class="flex-center mobile-project">
					<div class="project-info">
						<div class="item col-center">
							<div class="label">项目编号:</div>
							<div class="value">{{information.apply && information.apply.number}}</div>
						</div>
						<div class="item col-center">
							<div class="label">项目名称:</div>
							<div class="value">{{information.apply && information.apply.item_name}}</div>
						</div>
						<div class="item col-center">
							<div class="label">项目责任单位:</div>
							<div class="value">{{information.apply && information.apply.responsible_unit}}</div>
						</div>
					</div>
				</div>

				<div class="tabs-content">
					<div class="tab-switch flex-cb">
						<div :class="{'line':item.type === 'line','success':item.type === 'line' && information.apply.status > [0,2,4][log.type - 1] && index < information.apply.status && log.all == 2,'success':(item.type === 'line' && item.lineIndex < log.type && information.apply.status > index && log.all == 1 )||(item.type === 'line' && index < [0,2,4][log.type - 1] ) }"
							v-for="(item,index) in switchList" :key="index">
							<div class="line-error"
								v-if="item.type === 'line' && index < information.apply.status && information.apply.status > [0,2,4][log.type - 1] && log.all == 2">
								<i class="el-icon-close"></i>
							</div>
							<div v-if="item.type === 'line'"></div>
							<div class="switch-item"
								:class="{active:schedule == index,'wait':index <= schedule && !isOngoing && log.all == 0,'success': log.all == 2 && information.apply.status >= [0,2,4][log.type - 1] && index <= information.apply.status - 1 ,'success':(log.all == 1 && index <= information.apply.status - 1  && information.apply.status >= [0,2,4][log.type - 1]) || (index < [0,2,4][log.type - 1]),submitted:information.apply && !information.apply.new_type}"
								v-else>
								<div class="title">
									{{item.title[0]}}
									<!-- {{(index < [0,2,4][log.type - 1]) ? item.title[2] : index < information.apply.status ? (isOngoing ? item.title[0] : item.title[log.all+1]) : item.title[0]}} -->
								</div>
								<div class="date">{{item.date || '-'}}</div>
								<div class="sub">{{item.sub}}</div>
								<div class="seal" :class="{'wait':information.history && (information.history['type_'+['1','','2','','',''][index]] == 1),
									'success':information.history && (information.history['type_'+['1','','2','','',''][index]] == 2),
									'submitted':information.history && (information.history['type_'+['1','','2','','',''][index]] == 0)
									}" v-if="!(index == schedule && information.status == 1) && ((index == schedule && information.status == 2) || (index <= schedule && (!isOngoing || schedule > 0)))">
									<!-- {{[0,2,4][log.type - 1] < information.apply.status - 1 ? "(已超时)" : ""}} -->
									<span
										v-if="index === 0  && information.history && (information.history.type_1 || information.history.type_1 === 0) && information.history.type_1 !== ''">{{['未提交','已提交','已经归档'][information.history.type_1]}}</span>
									<span
										v-else-if="index === 2  && information.history && (information.history.type_2 || information.history.type_2 === 0) && information.history.type_2 !== ''">{{['未提交','已提交','已经归档'][information.history.type_2]}}</span>
									<span v-else-if="!information.apply.new_type">未提交</span>
									<span
										v-else-if="(log.all == 1 && index <= information.apply.status - 1  && information.apply.status >= [0,2,4][log.type - 1]) || (index < [0,2,4][log.type - 1])">{{ item.title[2]}}</span>
									<span
										v-else-if="log.all == 2 && information.apply.status >= [0,2,4][log.type - 1] && index <= information.apply.status - 1">{{ item.title[3]}}</span>
									<!-- {{[0,2,4][log.type - 1] < information.apply.status - 1 ? '(已超时)' : ''}} -->
									<span
										v-else-if="index <= [0,2,4][log.type - 1] && ((!isOngoing && schedule == 0) || log.all == 0 )">{{ item.title[1]}}</span>
									<!-- {{(index < [0,2,4][log.type - 1]) ? item.title[2] : index < information.apply.status ? (isOngoing ? item.title[1] : item.title[log.all+1]) : item.title[0]}} -->
								</div>
							</div>
						</div>
					</div>
					<div class="tab-center" v-if="isPeriod">
						<div>
							<div class="plan flex-sb">
								<div class="col-center">
									<div class="jewelry-title col-center">项目计划</div>
									<div class="submitted"
										v-if="information.status == 2 && isPeriod && (planList.length || log.plan > 0)"
										:class="[['tag-waiting','tag-success','tag-success'][log.plan]]">
										{{log.plan_status ? ['已提交','已经归档','已经归档'][log.plan] : '未提交'}}
									</div>
								</div>

								<div>
									<el-button type="primary" plain @click="planDialogVisible = true"
										:disabled="information.status == 2 && (disable || log.plan == 1 || ( log.plan != 1 && !log.plan_update)) ">+
										添加</el-button>
								</div>
							</div>
							<div class="refuse" v-if="log.plan == 2 && log.plan_desc && isPeriod">
								不通过原因：{{log.plan_desc}}</div>
							<div class="plan-group" v-if="planList && planList.length">
								<div class="plan-item col-center"
									:class="{'disabled':!item.is_update,'success':log.plan == 1 && item.id,'success':log.plan == 2 && item.id}"
									v-for="(item,index) in planList" :key="index">
									<div class="left col-center">
										<div class="date">{{item.date.join(' 至 ')}}</div>
										<div class="text">{{item.content}}</div>
									</div>
									<div class="right col-center">
										<div v-if="!item.is_update">
											<i class="el-icon-close" slot="reference" style="font-size: 1.25rem;"></i>
										</div>
										<div v-else>
											<el-popconfirm title="确定要删除当前数据吗？" @confirm="planDel(item,index)">
												<i class="el-icon-close" slot="reference"
													style="font-size: 1.25rem;"></i>
											</el-popconfirm>
										</div>
										<div @click="planEditor(item,index)"><i class="el-icon-edit"></i></div>
									</div>
								</div>
							</div>
							<div class="plan-group" style="text-align: center;" v-else>
								暂无数据
							</div>
						</div>
						<div>
							<div class="ach flex-sb">
								<div class="col-center">
									<div class="jewelry-title col-center">预期成果</div>
									<div class="submitted"
										v-if="information.status == 2 && isPeriod && (achList.length || log.achievement > 0)"
										:class="[['tag-waiting','tag-success','tag-success'][log.achievement]]">
										{{log.achievement_status ? ['已提交','已经归档','已经归档'][log.achievement] : '未提交'}}
									</div>
								</div>
								<div>
									<el-button type="primary" plain @click="achOpen"
										:disabled="information.status == 2 && (disable || log.achievement == 1 ||  (log.achievement != 1 && !log.achievement_update))">+
										添加</el-button>
								</div>
							</div>
							<div class="refuse" v-if="log.achievement == 2 && log.achievement_desc && isPeriod">
								不通过原因：{{log.achievement_desc}}</div>
							<div class="ach-group" v-if="achList && achList.length">
								<div v-for="(item,index) in achList" :key="index">
									<div class="ach-item col-center"
										:class="{disabled:!item.is_update,'success':log.achievement == 1 && item.id,'success':log.achievement == 2 && item.id}">
										<div class="left">
											<div class="ach-type">
												<!-- categoryList.filter(f => f.id == item.project_category_id)[0].name -->
												成果类型：{{item.project_category_name}}
											</div>
											<div class="ach-con">{{item.content}}</div>
											<el-dropdown v-if="item.earlier_files && item.earlier_files.length"
												placement="right"
												@command="handleCommand($event,item.earlier_files[0].url)">
												<div>
													<div class="ach-file">
														<!-- {{item.upload_file[0].url.split('/').pop()}} -->
														佐证材料：<span>{{item.earlier_files[0].name}}</span>
													</div>
												</div>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item command="download">下载<span
															style="color: red;margin-left: 0.625rem;">(预览较慢时请选择下载)</span></el-dropdown-item>
													<el-dropdown-item command="view">在线预览</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
										<div class="right col-center">
											<div v-if="!item.is_update">
												<i class="el-icon-close" slot="reference"
													style="font-size: 1.25rem;"></i>
											</div>
											<div v-else>
												<el-popconfirm title="确定要删除当前数据吗？" @confirm="achDel(item,index)">
													<i class="el-icon-close" slot="reference"
														style="font-size: 1.25rem;"></i>
												</el-popconfirm>
											</div>
											<div @click="achEditor(item,index)"><i class="el-icon-edit"></i></div>
										</div>
									</div>
									<div v-if="item.is_complete == 2 && schedule != 0"
										style="font-size: 14px;color: red;">完成请先上传佐证材料</div>
									<div class="floor col-center" v-if="schedule != 0">
										<div class="radio">
											<el-radio-group
												:disabled="!item.uploads_files || !item.uploads_files.length || log.achievement == 1"
												v-model="item.is_complete" @change="achRadioChange($event,index)">
												<el-radio :label="1">已完成</el-radio>
												<el-radio :label="2">未完成</el-radio>
											</el-radio-group>
										</div>
										<div class="col-center file">
											<div>佐证材料：</div>
											<upload text="点击上传佐证材料" :disabled="disable || log.achievement == 1"
												:localList="item.uploads_files" @success="achFileSuccess($event,index)">
											</upload>
										</div>
									</div>
								</div>
							</div>
							<div class="ach-group" style="text-align: center;padding-bottom: 1.25rem;" v-else>
								暂无数据
							</div>
						</div>
						<!-- 可示范推广的经验 -->
						<div>
							<div class="ach flex-sb wrap">
								<div class="col-center ">
									<div class="jewelry-title col-center">可示范推广的经验</div>
									<div class="submitted"
										v-if="information.status == 2 && isPeriod && (peList.length || log.experience > 0)"
										:class="[['tag-waiting','tag-success','tag-success'][log.experience]]">
										{{log.experience_status ? ['已提交','已经归档','已经归档'][log.experience] : '未提交'}}
									</div>
								</div>

								<div>
									<el-button type="primary" plain @click="peOpen"
										:disabled="information.status == 2 && (disable  || log.experience == 1 || (log.experience != 1 && !log.experience_update))">+
										添加</el-button>
								</div>
							</div>
							<div class="refuse" v-if="log.experience == 2 && log.experience_desc && isPeriod">
								不通过原因：{{log.experience_desc}}</div>
							<div class="ach-group" v-if="peList && peList.length">
								<div v-for="(item,index) in peList" :key="index">
									<div class="ach-item col-center"
										:class="{disabled:!item.is_update,'success':log.experience == 1 && item.id,'success':log.experience == 2 && item.id}">
										<div class="left">
											<div class="ach-type">标题：{{item.title}}</div>
											<div class="ach-con">{{item.content}}</div>
											<el-dropdown placement="right"
												v-if="item.earlier_files && item.earlier_files.length"
												@command="handleCommand($event,item.earlier_files[0].url)">
												<div>
													<div class="ach-file">
														<!-- {{item.upload_file[0].url.split('/').pop()}} -->
														佐证材料：<span>{{item.earlier_files[0].name}}</span>
													</div>
												</div>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item command="download">下载<span
															style="color: red;margin-left: 0.625rem;">(预览较慢时请选择下载)</span></el-dropdown-item>
													<el-dropdown-item command="view">在线预览</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
										<div class="right col-center">
											<div v-if="!item.is_update">
												<i class="el-icon-close" slot="reference"
													style="font-size: 1.25rem;"></i>
											</div>
											<div v-else>
												<el-popconfirm title="确定要删除当前数据吗？" @confirm="peDel(item,index)">
													<i class="el-icon-close" slot="reference"
														style="font-size: 1.25rem;"></i>
												</el-popconfirm>
											</div>
											<div @click="peEditor(item,index)"><i class="el-icon-edit"></i></div>
										</div>
									</div>
									<div v-if="item.is_complete == 2 && schedule != 0"
										style="font-size: 14px;color: red;">完成请先上传佐证材料</div>
									<div class="floor col-center" v-if="schedule != 0">
										<div class="radio">
											<el-radio-group
												:disabled="!item.uploads_files || !item.uploads_files.length || log.experience == 1"
												v-model="item.is_complete">
												<el-radio :label="1">已完成</el-radio>
												<el-radio :label="2">未完成</el-radio>
											</el-radio-group>
										</div>
										<div class="col-center file">
											<div>佐证材料：</div>
											<upload text="点击上传佐证材料" :disabled="disable || log.experience == 1"
												:localList="item.uploads_files" @success="peFileSuccess($event,index)">
											</upload>
										</div>
									</div>
								</div>
							</div>
							<div class="ach-group" style="text-align: center;padding-bottom: 1.25rem;" v-else>
								暂无数据
							</div>
						</div>
						<div>
							<div class="ach flex-sb">
								<div class="col-center wrap">
									<div class="jewelry-title col-center" style="padding-top: 6px;padding-bottom: 6px;">
										其他材料
									</div>
									<div class="submitted"
										v-if="information.status == 2 && isPeriod && (otherFiles && otherFiles.uploads_files.length || log.file > 0)"
										:class="[['tag-waiting','tag-success','tag-error'][log.file]]">
										{{log.file_status ? ['已提交','已经归档','已经归档'][log.file] : '未提交'}}
									</div>
									<span
										style="color: red;font-size: 14px;font-weight: 400;padding-left: 10px;">可上传开题报告(非必需)、中期进展(非必需)、结题报告等其他资料</span>
								</div>

								<div>
								</div>
							</div>
							<div class="refuse" v-if="log.file == 2 && log.file_desc && isPeriod">
								不通过原因：{{log.file_desc}}</div>
							<div style="margin-top: 10px;">
								<upload :localList="otherFiles.uploads_files" subtext=""
									:disabled="disable  || log.file == 1" :limit="9" @success="otherFile"></upload>
							</div>
						</div>
						<div class="col-center btn-group">
							<div>
								<el-button
									:disabled="disable || (information.status != 1 && !log.experience_update && !log.achievement_update && !log.plan_update)"
									@click="reset">重置</el-button>
							</div>
							<div>
								<el-button type="primary" plain @click="handleStorage('storage')"
									:disabled="disable || (information.status != 1 && !log.experience_update && !log.achievement_update && !log.plan_update)">暂存</el-button>
							</div>
							<div>
								<el-button type="primary" @click="configSubmit"
									:disabled="disable || (information.status != 1 && !log.experience_update && !log.achievement_update && !log.plan_update)">确认提交</el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 添加项目计划 -->
		<div class="detail-tips">
			<el-dialog :lock-scroll='false' :close-on-click-modal="false" :visible.sync="planDialogVisible"
				width="31.25rem" top="15vh" :before-close="planClose">
				<div class="dialog-head flex-sb" slot="title">
					<div>项目计划</div>
					<div><i class="el-icon-close"></i></div>
				</div>
				<div class="dialog-content">
					<el-form label-position='top' :model="planForm" :rules="planRules" ref="planForm"
						label-width="100px" class="demo-ruleForm">
						<el-form-item label="时间" prop="date" required>
							<el-date-picker value-format="yyyy-MM-dd" type="daterange" range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" placeholder="选择时间"
								v-model="planForm.date" style="width: 100%;"></el-date-picker>
						</el-form-item>
						<el-form-item label="计划内容" prop="content">
							<el-input resize="none" rows="5" type="textarea" v-model="planForm.content"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="planClose">取消</el-button>
					<el-button type="primary" @click="planAdd">确定</el-button>
				</span>
			</el-dialog>
		</div>
		<!-- 添加预期成果 -->
		<project-results :options="categoryList" ref="projectResults" @result="achAdd"></project-results>
		<!-- 添加可示范项目推广经验 -->
		<promotion-experience ref="experience" @result="peAdd"></promotion-experience>
		<!-- 在线预览 -->
		<view-doc ref="viewDoc"></view-doc>
	</div>
</template>

<script>
	import mainHeader from '@/components/main-header/main-header'
	import projectResults from './components/project-results'
	import promotionExperience from './components/promotion-experience'
	import viewDoc from './components/view-doc'
	import upload from './components/upload'
	// api
	import {
		getProcessDetail,
		getProcessCategory,
		processSave,
		processStorage
	} from '@/common/api/process.js'
	// 节流防抖
	import throttleDebounce from '@/utils/throttleDebounce.js'
	export default {
		name: '',
		props: {

		},
		components: {
			mainHeader,
			projectResults,
			upload,
			promotionExperience,
			viewDoc
		},
		data() {
			return {
				project_id: '',
				id: '',
				editorIndex: '',
				schedule: 0,
				child: [],
				switchList: [{
					title: ["项目开题", "已提交", "已经归档", '已经归档'],
					sub: '执行计划提交-预期成果提交'
				}, {
					type: 'line',
					lineIndex: 0
				}, {
					title: ["项目进展", "已提交", "已经归档", '已经归档'],
					sub: '资料提交'
				}, {
					type: 'line',
					lineIndex: 1
				}, {
					title: ["项目结题", "已提交", "已经归档", '已经归档'],
					sub: '资料提交'
				}],
				// 项目计划
				planList: [],
				planForm: {
					date: '',
					content: ''
				},
				planDialogVisible: false,
				planRules: {
					date: [{
						required: true,
						message: '请选择计划时间',
						trigger: 'change'
					}],
					content: [{
						required: true,
						message: '请输入计划内容',
						trigger: 'blur'
					}],
				},
				// 项目预期成果
				achList: [],
				categoryList: [],
				// 可示范推广的项目经验
				peList: [],
				// 
				information: {
					apply: {}
				},
				disable: false,
				// 其他附件上传
				otherFiles: {
					id: '',
					uploads_files: []
				},
				otherFilesList: [],
				isOngoing: false,
				isPeriod: true,
				log: {},
				reviewStatus: [true, true],
				openUrl: ''
			}
		},
		created() {
			this.project_id = this.$route.query.audit_project_id
			this.id = this.$route.query.id
			this.getProcessCategory()
		},
		mounted() {
			// 添加面包屑
			this.child = [{
				path: "/index",
				name: "Index",
				title: this.authority === 'expert' ? '参赛作品评审' : '首页'
			}]
		},
		methods: {
			// 获取分类
			async getProcessCategory() {
				try {
					const {
						data
					} = await getProcessCategory({
						project_id: this.project_id
					})
					console.log(data, 8998989)
					this.categoryList = data
					this.getProcessDetail()
				} catch (e) {
					//TODO handle the exception
				}
			},
			// 获取详情
			async getProcessDetail() {
				try {
					const {
						data
					} = await getProcessDetail({
						id: this.id
					})
					console.log(data, '22222222')
					this.information = data
					this.switchList[0].date = data.date.approval_start_time + '~' + data.date.approval_end_time
					this.switchList[2].date = data.date.metaphase_start_time + '~' + data.date.metaphase_end_time
					this.switchList[4].date = data.date.conclude_start_time + '~' + data.date.conclude_end_time
					this.schedule = [0, 1, 2, 3, 4, 5][data.apply.status - 1]
					if (this.schedule === 5) {
						this.disable = true
					}
					this.log = data.log
					if (!data.plan.length && !data.achievement.length && !data.experience.length && !data.files
						.length) {
						this.isOngoing = true
					}
					if (this.schedule == 1 || this.schedule == 3 || this.schedule == 5) {
						this.disable = true
						this.isPeriod = false
						return
					}

					// if (this.schedule > [0, 2, 4][data.log.type - 1]) {
					// 	this.disable = true
					// }
					if (this.schedule > [0, 2, 4][data.log.type - 1]) {
						this.schedule = [0, 2, 4][data.log.type - 1]
					}
					this.planList = data.plan.map((item, index) => {
						item.date = [item.start_time, item.end_time]
						return item
					})
					this.achList = data.achievement
					this.peList = data.experience
					if (data.files && data.files.uploads_files) {
						this.otherFiles = data.files
					}
					console.log(this.disable, 'disabledisabledisable')
					this.$forceUpdate()
				} catch (e) {
					if (e.status_code == 350) {
						this.disable = true
					}
					//TODO handle the exception

				}
			},
			configSubmit() {
				this.$confirm('提交前请检查是否填写完整，是否确认提交?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.processSave()
				})
			},
			handleStorage: throttleDebounce.debounce(function(f) {
				//  需要节流的事件，我这里是接口的调取
				console.log("节流", f)
				this.processSave(f)
			}, 500),
			// (f) {
			// 	throttleDebounce.throttle(() => {
			// 		//  需要节流的事件，我这里是接口的调取
			// 		console.log("节流")
			// 		this.processSave(f)
			// 	}, 3000)
			// },

			// 保存
			async processSave(flag) {
				let pre = {
					plan: [],
					id: this.id
				}
				pre.plan = this.planList.map((item) => {
					item.start_time = item.date[0]
					item.end_time = item.date[1]
					return item
				})
				pre.achievement = this.achList.map((item) => {
					if (!item.is_complete) {
						item.is_complete = 2
					}
					return item
				})
				pre.experience = this.peList.map((item) => {
					if (!item.is_complete) {
						item.is_complete = 2
					}
					return item
				})
				console.log(this.otherFilesList)
				this.otherFiles.uploads_files = JSON.parse(JSON.stringify(this.otherFilesList))
				pre.files = this.otherFiles
				let fun = flag === 'storage' ? processStorage : processSave;
				try {
					const {
						data
					} = await fun(pre)
					console.log(data)
					this.$message({
						message: '保存成功',
						type: 'success'
					});
					this.getProcessDetail()
				} catch (e) {
					//TODO handle the exception
				}
			},
			reset() {
				this.$confirm('是否清空所有内容?保存后不可恢复！', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.planList = []
					this.achList = []
					this.peList = []
				})
			},
			planClose() {
				this.planForm = {
					date: '',
					content: ''
				}
				this.planDialogVisible = false
			},
			planAdd() {
				this.$refs.planForm.validate((valid) => {
					if (valid) {
						let res = JSON.parse(JSON.stringify(this.planForm))
						res.is_update = true
						if (this.editorIndex === '') {
							this.planList.push(res)
						} else {
							this.planList[this.editorIndex] = res
							this.editorIndex = ''
							this.$forceUpdate()
						}
						this.planClose()
					} else {
						return false;
					}
				});
			},
			planDel(item, index) {
				if (!item.is_update) {
					return
				}
				if (this.log.plan == 1) {
					return
				}
				this.planList.splice(index, 1)
			},
			planEditor(item, index) {
				if (!item.is_update) {
					return
				}
				if (this.log.plan == 1) {
					return
				}
				this.planForm = JSON.parse(JSON.stringify(item))
				console.log(this.planForm)
				this.planDialogVisible = true
				this.editorIndex = index
			},
			// 预期成果
			achOpen() {
				this.$refs.projectResults.dialogVisible = true
			},
			achAdd(item) {
				item.is_update = true
				let name = this.categoryList.filter(f => f.id == item.project_category_id)
				if (name && name.length) {
					item.project_category_name = name[0].name
				}
				if (this.editorIndex === '') {
					this.achList.push(item)
				} else {
					this.achList[this.editorIndex] = item
					this.editorIndex = ''
					this.$forceUpdate()
				}
			},
			achDel(item, index) {
				if (!item.is_update) {
					return
				}
				if (this.log.achievement == 1) {
					return
				}
				this.achList.splice(index, 1)
			},
			achEditor(item, index) {
				if (!item.is_update) {
					return
				}
				if (this.log.achievement == 1) {
					return
				}
				let form = JSON.parse(JSON.stringify(item))
				this.$refs.projectResults.fileList = form.earlier_files || []
				this.$refs.projectResults.form = form
				this.$refs.projectResults.dialogVisible = true
				this.editorIndex = index
			},
			achRadioChange(e, index) {
				console.log(e, 1111111)
			},
			achFileSuccess(e, index) {
				if (e.length) {
					this.achList[index].is_complete = 1
				} else {
					this.achList[index].is_complete = 2
				}
				// this.achList[index].is_complete = 1
				this.achList[index].uploads_files = e
				this.$forceUpdate()
			},
			// 可示范推广的经验
			peOpen() {
				this.$refs.experience.dialogVisible = true
			},
			peAdd(item) {
				item.is_update = true
				if (this.editorIndex === '') {
					this.peList.push(item)
				} else {
					this.peList[this.editorIndex] = item
					this.$forceUpdate()
					this.editorIndex = ''
				}
			},
			peDel(item, index) {
				if (!item.is_update) {
					return
				}
				if (this.log.experience == 1) {
					return
				}
				this.peList.splice(index, 1)
			},
			peEditor(item, index) {
				if (!item.is_update) {
					return
				}
				if (this.log.experience == 1) {
					return
				}
				let form = JSON.parse(JSON.stringify(item))
				this.$refs.experience.fileList = form.earlier_files || []
				this.$refs.experience.form = form
				this.$refs.experience.dialogVisible = true
				this.editorIndex = index
			},
			peFileSuccess(e, index) {
				if (e.length) {
					this.peList[index].is_complete = 1
				} else {
					this.peList[index].is_complete = 2
				}

				this.peList[index].uploads_files = e
				this.$forceUpdate()
			},
			// 其他附件
			otherFile(e) {
				console.log(e, 22222222)
				this.otherFilesList = e
			},
			// 操作菜单
			handleCommand(command, url) {
				if (command === 'download') {
					window.open(url, '_blank')
				} else {
					this.viewFile(url)
				}
			},
			// 在线预览
			viewFile(url) {
				this.$refs.viewDoc.open(url, (this.authority === 'expert' ? true : false))
				return
				let onlineViewType = ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx']
				let fileTypeName = url.substring(url.lastIndexOf('.') + 1, url.length).split('?')[0]
				let isWord = onlineViewType.find((type) => type === fileTypeName)
				if (isWord) {
					url = 'http://view.officeapps.live.com/op/view.aspx?src=' + url
				}
				window.open(url, '_blank')
			},
			opener() {
				if (this.openUrl) {
					window.open(this.openUrl)
				}
			}
		}

	}
</script>

<style lang="scss" scoped>
	.h-container {
		width: 100vw;
		height: 100vh;
		background-color: #F7F7F7;
		display: flex;
		flex-direction: column;

		.i-h {
			flex-shrink: 0;
		}

		.content {
			flex-grow: 1;
			height: 0;
			margin: 0.625rem;
			border-radius: 0.375rem;
			background-color: white;
			display: flex;
			flex-direction: column;

			.jewelry-title {
				font-size: 1.25rem;
				font-weight: bold;
				position: relative;
				padding-left: 1.5rem;
				padding-right: 1.5rem;
				padding-top: 0.625rem;
				padding-bottom: 0.625rem;
				background-color: #4389E0;
				color: white;
				border-radius: 4px;
			}

			.submitted {
				padding-left: 20px;
				color: #4979ff;
				font-weight: bold;
			}

			.tag-success {
				padding-left: 20px;
				color: #54cd17;
				font-weight: bold;
			}

			.tag-error {
				padding-left: 20px;
				color: red;
				font-weight: bold;
			}

			.tag-waiting {
				padding-left: 20px;
				color: #4979ff;
				font-weight: bold;
			}

			.jewelry-title::after {
				content: "";
				display: block;
				width: 0.25rem;
				height: 1rem;
				position: absolute;

				left: 0.625rem;
				top: 50%;
				margin-top: -8px;
			}

			.project-info {
				border: 1px solid #666;
				padding: 10px 20px;
				margin-top: 10px;
				border-radius: 10px;

				.item {
					padding: 5px 0;
				}

				.label {
					font-size: 16px;
					padding-right: 10px;
					font-weight: bold;
					flex-shrink: 0;
				}

				.value {
					font-size: 16px;
					color: #4979ff;
				}
			}

			.content-nav {
				padding: 1.25rem;
				border-bottom: 1px solid #E7EBF0;
				flex-shrink: 0;

				.project-info {
					border: 0 none;
					margin-top: 0;

					.item {
						margin-right: 30px;
					}
				}


				.title {
					font-size: 1.5rem;
					font-weight: bold;
					position: relative;
					padding-left: 1.5rem;
				}

				.title::after {
					content: "";
					display: block;
					width: 0.25rem;
					height: 1rem;
					position: absolute;
					background-color: #4389E0;
					left: 0.625rem;
					top: 50%;
					margin-top: -8px;
				}

				.right {
					.search {
						padding: 0 4.375rem;
						width: 20rem;
					}

					.search-btn {
						padding: 0 0.625rem;
					}
				}

				.seeManual {
					text-decoration: underline;
					cursor: pointer;
				}

				.seeManual:hover {
					color: #409EFF;
				}
			}

			.mobile-project {
				display: none;
			}

			.tabs-content {
				width: 82.5rem;
				margin: 0 auto;

				.tab-switch {
					padding: 1.875rem;

					.switch-item {
						padding: 0.625rem 0;
						width: 15rem;
						text-align: center;
						background: #FFFFFF;
						border-radius: 10px;
						border: 1px solid #ACC1DA;
						color: #464646;
						// cursor: pointer;
						position: relative;

						.title {
							font-size: 1.25rem;
							font-weight: bold;

						}

						.date {
							font-size: 0.875rem;
							padding: 4px 0;
						}

						.sub {}

						.seal {
							position: absolute;
							z-index: 2;
							border-radius: 0.25rem;
							transform: rotate(45deg);
							padding: 0.375rem 0.625rem;
							right: -26px;
							top: -2px;
							border: 1px solid rgb(102, 177, 255);
							color: #409EFF;
							animation: endReview 1s;
							background-color: rgba(198, 226, 255, .8);
						}

						.seal.wait {
							border: 1px solid rgb(102, 177, 255) !important;
							background-color: rgba(198, 226, 255, .8) !important;
							color: #409EFF !important;
						}

						.seal.success {
							border: 1px solid #67C23A !important;
							color: #40c100 !important;
							transform: scale(1) rotate(45deg) !important;
							right: -26px !important;
							top: -2px !important;
							background-color: rgba(225, 243, 216, .8) !important;
						}
					}

					.switch-item.active {
						background-color: #4389DF;
						color: white;
					}

					.switch-item.wait {
						.seal {
							border: 1px solid rgb(102, 177, 255);
							color: #409EFF;
							// top: 0px;
							// right: -60px;
							// transform: scale(.7) rotate(45deg);
							background-color: rgba(198, 226, 255, .8);
						}
					}

					.switch-item.error {
						.seal {
							border: 1px solid #F56C6C;
							color: red;
							transform: scale(1) rotate(45deg);
							right: -26px;
							top: -2px;
							background-color: rgba(253, 226, 226, .8);
						}

					}

					.switch-item.success {
						.seal {
							border: 1px solid #67C23A;
							color: #40c100;
							transform: scale(1) rotate(45deg);
							right: -26px;
							top: -2px;
							background-color: rgba(225, 243, 216, .8);
						}

					}

					.switch-item.submitted {
						.seal {
							border: 1px solid #E6A23C;
							color: #E6A23C;
							transform: scale(1) rotate(45deg);
							right: -26px;
							top: -2px;
							background-color: rgba(250, 236, 216, .8);
						}
					}

					.line {
						height: 1px;
						background-color: #DCE1E7;
						flex-grow: 1;
						position: relative;
					}

					.line::after {
						position: absolute;
						content: '';
						display: block;
						border-left: 0.625rem solid #C3DEFF;
						border-top: 0.5rem solid transparent;
						border-right: 0.625rem solid transparent;
						border-bottom: 0.5rem solid transparent;
						left: 50%;
						top: 50%;
						margin-top: -0.5rem;
						margin-left: -0.625rem;
					}



					.line.error {
						background-color: #F56C6C;
					}

					.error.line::after {
						border-left: 0.625rem solid transparent;
						content: '';
						border-color: white;
					}

					.success.line {
						background-color: #67C23A;

						.line-error {
							display: none;
						}
					}

					.success.line::after {
						border-color: transparent;
						border-left: 0.625rem solid #67C23A;
					}

					.line-error {
						left: 50%;
						top: 50%;
						margin-top: -0.65rem;
						margin-left: -0.625rem;
						color: #F56C6C;
						position: absolute;
						font-size: 1.25rem;
						z-index: 3;

						.el-icon-close {
							font-weight: bold;
						}
					}
				}

				.tab-center {
					background: #F7F9FB;
					border-radius: 4px;
					border: 1px solid #D0D5DB;
					padding: 1.875rem;

					.plan {}

					.refuse {
						padding-top: 1.25rem;
						color: red;
						font-size: 14px;
					}

					.plan-group {
						padding: 1.25rem 0;


						.plan-item.success {
							.left {
								border-color: #67C23A;
							}

							.right {
								color: #58a631;

								i {
									cursor: not-allowed;
								}
							}

							.right i:hover {
								color: #58a631;
							}
						}

						.plan-item.error {
							.left {
								border-color: #F56C6C;
							}
						}

						.plan-item {
							padding-bottom: 0.625rem;

							.left {
								padding: 0.875rem;
								background-color: white;
								border: 1px solid #E3E7EC;
								border-radius: 4px;
								flex-grow: 1;
								width: 0;

								.date {
									font-weight: bold;
									flex-shrink: 0;
								}

								.text {
									padding-left: 0.625rem;
								}
							}

							.right {
								color: #4389DF;
								cursor: pointer;

								i {
									margin-left: 0.625rem;
								}
							}

							.right i:hover {
								color: #0000ff;
							}
						}

						.disabled.plan-item {
							.left {
								background-color: #f2f2f2;
							}

							.right {
								color: #999;

								i {
									cursor: not-allowed;
								}
							}

							.right i:hover {
								color: #999;
							}
						}
					}

					.ach-group {
						padding-top: 1.25rem;

						.disabled.ach-item {
							.left {
								background-color: #f2f2f2;
							}

							.right {
								color: #999;

								i {
									cursor: not-allowed;
								}
							}

							.right i:hover {
								color: #999;
							}
						}

						.ach-item.success {
							.left {
								border-color: #67C23A;
							}

							.right {
								color: #58a631;

								i {
									cursor: not-allowed;
								}
							}

							.right i:hover {
								color: #58a631;
							}
						}

						.ach-item.error {
							.left {
								border-color: #F56C6C;
							}
						}

						.ach-item {
							padding-bottom: 1.25rem;

							.left {
								flex-grow: 1;
								width: 0;
								padding: 1.25rem;
								background: #FFFFFF;
								border-radius: 4px;
								border: 1px solid #E3E7EC;


								.ach-type {
									font-weight: bold;
								}

								.ach-con {
									padding: 0.25rem 0;
									white-space: pre-wrap;
									font-size: 0.875rem;
								}

								.ach-file {
									span {
										color: #4389DF;
									}

									span:hover {
										cursor: pointer;
										text-decoration: underline;
									}
								}
							}

							.right {
								color: #4389DF;
								cursor: pointer;

								i {
									margin-left: 0.625rem;
								}
							}

							.right i:hover {
								color: #0000ff;
							}
						}

						.floor {
							padding-bottom: 1.25rem;

							.radio {
								padding-top: 2px;
							}

							.file {
								padding-left: 1.25rem;
								font-size: 0.875rem;
							}
						}
					}

					.btn-group {
						justify-content: flex-end;

						div {
							padding-left: 1.25rem;
						}
					}
				}
			}
		}
	}

	@keyframes endReview {
		from {
			transform: rotate(45deg) scale(3);
		}

		to {
			transform: rotate(45deg) scale(1);
		}
	}

	::v-deep .el-button--primary.is-plain {
		color: #409EFF !important;
		background-color: #ecf5ff !important;
	}

	// ::v-deep .el-button.el-button--primary.is-plain {
	// 	span {
	// 		color: #409EFF !important;
	// 	}
	// }

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.h-container {
			.content {
				.content-nav {
					display: block;

					.title {
						font-size: 1.125rem;
					}

					.right {
						.search {
							padding: 1.25rem 0 0;
							width: 100%;

							.el-input {
								width: auto;
								flex-grow: 1;

								::v-deep {
									.el-input {
										width: 100%;
									}
								}
							}
						}

						.sub-btn {
							padding: 1.25rem 0 0 1.25rem;
						}
					}

					.project-info {
						display: none;
					}
				}

				.mobile-project {
					display: flex;

					.project-info {
						border-color: #999;
						padding: 5px 10px;

						.label {
							font-size: 12px;
						}

						.value {
							font-size: 12px;
						}

						.item {
							padding: 0;
						}
					}
				}

				.tabs-content {
					width: 100%;

					.tab-switch {
						flex-wrap: wrap;
						justify-content: center;
						padding: 20px;

						.line {
							display: none;
						}

						.switch-item {
							margin-top: 20px;
						}
					}

					.tab-center {
						padding: 10px;

						.plan-group {
							.plan-item {
								.left {
									flex-wrap: wrap;
									padding: 10px;

									.text {
										padding-left: 0;
										margin-top: 5px;
									}
								}
							}
						}

						.ach-group {
							.ach-item {
								.left {
									flex-wrap: wrap;
									padding: 10px;
								}
							}

							.floor {
								flex-wrap: wrap;

								.radio {
									padding: 5px 0;
								}

								.file {
									padding-left: 0;
								}

								::v-deep {
									.el-upload__tip {
										display: none;
									}
								}
							}
						}
					}
				}

			}
		}

		::v-deep {
			.el-dialog {
				width: 100% !important;
			}
		}
	}
</style>